<div class="ct-main-content">
  <div class="ct-container">
    <div class="main-label">MEUS PEDIDOS</div>

    @if (!onlineOrders || onlineOrders.length == 0) {
      <div class="no-results">
        <hr/>
        @if (!loading) {
          <div>
            Nenhum pedido localizado.
            @if (!customer || !customer.token) {
              <a (click)="goToLogin($event)" href="#">Você está cadastrado?</a>
            }
          </div>
        }
        @if (loading) {
          <div class="loading-icon">
            <fa-icon [icon]="faUtensils" [animation]="'spin'"></fa-icon>
          </div>
        }
      </div>
    }

    <div class="main-content">
      @for (oo of onlineOrders; track oo) {
        <div class="obj-item" (click)="onlineOrderDetails(oo)">
          <hr/>
          <div class="item-header">
            <span class="item-name">
              {{ oo.prettyCompanyName }}
            </span>
            <span class="item-status">
              <span class="badge badge-secondary status-badge {{ oo.status }}">{{ oo.statusPtBr }}</span>
            </span>
          </div>
          <div class="item-body">
            <div class="time-since">
              <fa-icon [icon]="faClock"></fa-icon>{{ oo.timeSince }}
            </div>
            @if (!oo.reason) {
              <div class="mode">
                {{ oo.parsedDeliveryInfo.mode == 'delivery' ? 'Delivery' : 'Retirada no local' }}
              </div>
            }
            @if (oo.reason) {
              <div class="mode reason">
                "{{ oo.reason }}"
              </div>
            }
            <div class="price">
              <span>
                Total: {{ oo.prettyTotal }}
              </span>
            </div>
          </div>
          <div class="item-footer">
            @if (oo.status == 'pending') {
              <span>
                <app-contact-buttons [company]="oo.company" [whatsMsg]="whatsMsg"></app-contact-buttons>
              </span>
            }
            @if (oo.status == 'cancelled') {
              <span>
                <app-contact-buttons [company]="oo.company" [whatsMsg]="whatsMsg"></app-contact-buttons>
              </span>
            }
            @if (oo.status == 'confirmed') {
              <span>
                <app-contact-buttons [company]="oo.company" [whatsMsg]="whatsMsg"></app-contact-buttons>
              </span>
            }
            @if (oo.status == 'producing') {
              <span>
                <app-contact-buttons [company]="oo.company" [whatsMsg]="whatsMsg"></app-contact-buttons>
              </span>
            }
            @if (oo.status == 'produced') {
              <span>
                <app-contact-buttons [company]="oo.company" [whatsMsg]="whatsMsg"></app-contact-buttons>
              </span>
            }
            @if (oo.status == 'in_transit') {
              <span>
                <button class="btn btn-md btn-primary">
                  <fa-icon [icon]="faMapMarker"></fa-icon>
                </button>
              </span>
            }
            @if (oo.status == 'delivered') {
              <span>
                <app-contact-buttons [company]="oo.company" [whatsMsg]="whatsMsg"></app-contact-buttons>
                &nbsp;
                <button class="btn btn-md btn-primary" (click)="giveFeedback(oo)">
                  <fa-icon [icon]="faCommentDots"></fa-icon>
                </button>
              </span>
            }
            @if (oo.status == 'evaluated') {
              <span>
              </span>
            }
          </div>
        </div>
      }
    </div>

    <hr/>
    <div class="main-content-footer">
      <button class="btn btn-lg btn-secondary back-button" (click)="goBack()">Voltar</button>
    </div>

    <!-- Commented out section remains unchanged -->
    <!-- <div class="online-order-footer"> ... </div> -->
  </div>
</div>